// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zervant-tabs {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
}
.zervant-tabs .zervant-tabs-switches {
  -webkit-box-flex: 1;
      -ms-flex-positive: 1;
          flex-grow: 1;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.zervant-tabs .zervant-tabs-switches .zervant-tabs-switch {
  -webkit-box-flex: 1;
      -ms-flex-positive: 1;
          flex-grow: 1;
}
.zervant-tabs .zervant-tabs-content-wrap {
  -webkit-box-flex: 1;
      -ms-flex-positive: 1;
          flex-grow: 1;
}`, "",{"version":3,"sources":["webpack://./src/client/components/common/Tabs/Tabs.scss"],"names":[],"mappings":"AACA;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,4BAAA;EAAA,6BAAA;MAAA,0BAAA;UAAA,sBAAA;AAAF;AACE;EACE,mBAAA;MAAA,oBAAA;UAAA,YAAA;EACA,oBAAA;EAAA,oBAAA;EAAA,aAAA;AACJ;AAAI;EACE,mBAAA;MAAA,oBAAA;UAAA,YAAA;AAEN;AACE;EACE,mBAAA;MAAA,oBAAA;UAAA,YAAA;AACJ","sourcesContent":["@import '../../../Global/Colors';\n.zervant-tabs {\n  display: flex;\n  flex-direction: column;\n  .zervant-tabs-switches {\n    flex-grow: 1;\n    display: flex;\n    .zervant-tabs-switch {\n      flex-grow: 1;\n    }\n  }\n  .zervant-tabs-content-wrap {\n    flex-grow: 1;\n  }\n}\n\n@mixin UnderlinedTabsRules {\n  .zervant-tabs-switches {\n    border-bottom: 1px solid $Gray30;\n\n    .zervant-tabs-switch {\n      color: $Gray90;\n      font-size: 12px;\n      margin-right: 24px;\n      cursor: pointer;\n      flex-grow: initial;\n      padding-bottom: 8px;\n\n      &.active-tab {\n        color: $DeepSeaGreen;\n        border-bottom: 1px solid $ElectricGreen;\n        margin-bottom: -1px;\n      }\n    }\n  }\n\n  .zervant-tabs-content-wrap {\n    .zervant-tabs-content {\n      margin-top: 24px;\n    }\n  }\n\n  .tabs-switch-0 {\n    color: $Purple !important;\n\n    &.active-tab {\n      border-bottom: 1px solid $Purple !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
